import { createSlice } from "@reduxjs/toolkit";
import { orderBy, QueryConstraint } from "firebase/firestore";
import { FirestoreService } from "../../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../api/firebase/references";
import { NYCBSMedicalPA } from "../../../data-model/nycbsMedicalPa";
import { logDataToConsole } from "../../../utils/customLogger";

export interface NYCBSMedicalPASlice {
  data: NYCBSMedicalPA[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: NYCBSMedicalPASlice = {
  data: null,
  loading: false,
  error: null,
};

const nycbsMedicalPaSlice = createSlice({
  name: "nycbsMedicalPa",
  initialState,
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const fetchNycbsMedicalPaOrdersFromFirebase =
  () => async (dispatch, getState) => {
    const { nycbsMedicalPa } = getState();
    if (nycbsMedicalPa.loading) return;

    dispatch(nycbsMedicalPaSlice.actions.setLoading(true));

    const queryConstraints: QueryConstraint[] = [orderBy("created_at", "desc")];

    const unsubscribe =
      FirestoreService.listenToQueryCollection<NYCBSMedicalPA>(
        FirestoreCollectionReference.nycbsMedicalPa(),
        (nycbsMedicalPa) => {
          logDataToConsole("nycbsMedicalPa", nycbsMedicalPa);
          dispatch(nycbsMedicalPaSlice.actions.setData(nycbsMedicalPa));
        },
        (error) => {
          dispatch(nycbsMedicalPaSlice.actions.setError(error.message));
        },
        ...queryConstraints,
      );

    return unsubscribe;
  };

export default nycbsMedicalPaSlice.reducer;
